module.exports = __webpack_public_path__ + "static/media/16_1.68013248.jpg";